// src/services/authService.ts
import {BASE_AUTH_API, fetchAPI} from '@/services/api';
import {UserPermission} from "@/store/admin/userPermission";
import {UserInfo} from "@/store/admin/userInfo";

// 登录参数类型
type LoginParams = {
    username: string;
    loginType: number;
    password: string;
    salt: string;
};

// response type
type LoginResponse = {
    adminToken: string;
    needChangePassword?: boolean;
};

const defaultUrl = BASE_AUTH_API;

// login API
export async function login(params: LoginParams): Promise<LoginResponse> {
    return fetchAPI<LoginResponse>(defaultUrl + `/login`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {'Content-Type': 'application/json'},
    });
}

// logout API
export async function logout(): Promise<void> {
    return fetchAPI<void>(defaultUrl + `/logOut`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}

// 为兼容调用方命名，导出别名 logOut
export {logout as logOut};

// 校验当前登录态（基于 HttpOnly Cookie）
export async function checkPermission(url: string, method?: string): Promise<{ uri: string }> {
    const qs = new URLSearchParams({ uri: url });
    if (method) {
        qs.set('method', method);
    }
    return fetchAPI<{ uri: string }>(defaultUrl + `/permission?${qs.toString()}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}

export async function introspect() {
    return fetchAPI<UserInfo>(defaultUrl + `/introspect`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}

export async function permissions() {
    return fetchAPI<UserPermission>(`/auth/permissions`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}